import { useMemo } from "react";
import { useOrders } from "../../util/OrderContext";
import { IProcessedOrders } from "../constants";



export function usePickupNow() {
    const { newOrders, openedOrders } = useOrders()!;

    const isPickupNow = useMemo(() => {
        if (!newOrders || !openedOrders ||
            !Array.isArray(newOrders) || !Array.isArray(openedOrders)) {
            return false
        };
        const orders = [...newOrders, ...openedOrders] as IProcessedOrders[];
        let isPickup = false;
        for (const item of orders) {
            if (item?.order_type === "COLLECTION_POINT_PICKUP") {
                isPickup = true;
                break;
            }
        }
        return isPickup;
    }, [newOrders, openedOrders]);

    return isPickupNow;
}

